import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularLightbulb: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_lightbulb"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="lightbulb icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M12 2.00195C16.0041 2.00195 19.25 5.24789 19.25 9.25195C19.25 11.348 18.3493 13.2717 16.5869 14.9939C16.51 15.0691 16.4504 15.1596 16.4118 15.2592L16.3804 15.3615L15.2493 20.2571C15.0266 21.221 14.2035 21.9193 13.2302 21.9939L13.057 22.0006H10.9433C9.95374 22.0006 9.08791 21.3555 8.79629 20.4238L8.75088 20.2565L7.62132 15.3617C7.58904 15.2218 7.51728 15.0941 7.41456 14.9938C5.73515 13.3536 4.83778 11.5307 4.75613 9.55021L4.75 9.25195L4.75388 9.01264C4.88014 5.11935 8.07601 2.00195 12 2.00195ZM14.115 18.5H9.884L10.2125 19.9192C10.2831 20.2255 10.5357 20.4514 10.8401 20.4935L10.9433 20.5006H13.057C13.3713 20.5006 13.6481 20.3054 13.7577 20.0183L13.7878 19.9194L14.115 18.5ZM12 3.50195C8.89821 3.50195 6.37006 5.95797 6.25415 9.0314L6.25 9.25195L6.25672 9.52896C6.33286 11.0923 7.05722 12.5481 8.46262 13.9207C8.72675 14.1787 8.92265 14.497 9.03422 14.8469L9.08291 15.0244L9.538 17H14.461L14.9189 15.0238C15.0019 14.6644 15.1718 14.3319 15.4124 14.0548L15.5386 13.9211C16.9432 12.5485 17.6672 11.0926 17.7433 9.529L17.75 9.25195L17.7458 9.0314C17.6299 5.95797 15.1018 3.50195 12 3.50195Z" />
      </svg>
    </span>
  );
};

export { RegularLightbulb };
